import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledOutlineButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_DISABLE_BUTTONS, RAISED_DISABLE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedDisabledOutlineButtons = () => {
    return (
        <Card>
          <CommonCardHeader title={DisabledOutlineButton} span={RAISED_DISABLE_BUTTONS} />
          <CardBody className="btn-showcase">
            <Btn disabled outline color="primary" className="btn-pill btn-air-primary">{Disabled}</Btn>
            {RAISED_DISABLE_BUTTONS_LIST.map((data, index) => (
              <CommonRaisedButton key={index} item={data} disabled outline/>
            ))}
          </CardBody>
        </Card>
      );
};

export default RaisedDisabledOutlineButtons;
